import { css } from '@emotion/react'
import {
  Spacing,
  CornerRadius,
  gemVar,
  ThemedColors,
  Overlay,
} from '@opallabs/gem'
import { ITEM_HEIGHT } from '../styles'

export const FOOTER_ID = 'cascading-menu-footer'

export const footer = css({
  alignItems: 'center',
  borderRadius: CornerRadius.Small,
  color: gemVar(ThemedColors.TextSecondary),
  display: 'flex',
  gap: Spacing.XS,
  inlineSize: '100%',
  margin: `${Spacing.XS}px 0`,
  minBlockSize: ITEM_HEIGHT,
  padding: `0 ${Spacing.S}px`,
})

export const footerHoverStyles = css({
  cursor: 'pointer',

  '[data-gem-theme="light"] &': {
    '&:hover, &:focus': {
      backgroundColor: Overlay.BL200['08'],
    },
  },
  '[data-gem-theme="dark"] &': {
    '&:hover, &:focus': {
      backgroundColor: Overlay.BD200['16'],
    },
  },
  '&[aria-disabled=true]': {
    color: gemVar(ThemedColors.TextSecondary),
    cursor: 'not-allowed',

    '&:hover, &:focus': { background: 'transparent' },
  },
})
